module.exports = __webpack_public_path__ + "img/cover-ajanspress.d4458160.jpg";